/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs */

const en_svc_rag_knowledge_assistants_retrieve_desc8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chunk strategy and reranking tuned until answers cite the right passages.`)
};

const ar_svc_rag_knowledge_assistants_retrieve_desc8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استراتيجية التقطيع وإعادة الترتيب تضبط حتى تستشهد الإجابات بالمقاطع الصحيحة.`)
};

const bn_svc_rag_knowledge_assistants_retrieve_desc8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চাঙ্ক কৌশল আর রির‍্যাঙ্কিং টিউন করা হয় যতক্ষণ উত্তর সঠিক অংশ উদ্ধৃত করে।`)
};

const de_svc_rag_knowledge_assistants_retrieve_desc8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chunk-Strategie und Reranking werden abgestimmt, bis Antworten die richtigen Stellen zitieren.`)
};

const es_svc_rag_knowledge_assistants_retrieve_desc8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrategia de fragmentos y reordenación ajustadas hasta que las respuestas citen los pasajes correctos.`)
};

const fr_svc_rag_knowledge_assistants_retrieve_desc8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stratégie de découpage et reclassement réglés jusqu'à ce que les réponses citent les bons passages.`)
};

const pt_svc_rag_knowledge_assistants_retrieve_desc8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estratégia de fragmentos e reordenação afinadas até as respostas citarem as passagens certas.`)
};

const zh_svc_rag_knowledge_assistants_retrieve_desc8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`调整切分策略和重排，直到回答引用到正确的段落。`)
};

const tr_svc_rag_knowledge_assistants_retrieve_desc8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parça stratejisi ve yeniden sıralama, yanıtlar doğru pasajları alıntılayana dek ayarlanır.`)
};

const ru_svc_rag_knowledge_assistants_retrieve_desc8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стратегия чанков и реранкинг настраиваются, пока ответы не начнут цитировать нужные места.`)
};

const pl_svc_rag_knowledge_assistants_retrieve_desc8 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategia chunków i reranking dostrajane, aż odpowiedzi zaczną cytować właściwe fragmenty.`)
};

/**
* | output |
* | --- |
* | "Chunk strategy and reranking tuned until answers cite the right passages." |
*
* @param {Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_retrieve_desc8 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Retrieve_Desc8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_retrieve_desc8(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_retrieve_desc8(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_retrieve_desc8(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_retrieve_desc8(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_retrieve_desc8(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_retrieve_desc8(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_retrieve_desc8(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_retrieve_desc8(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_retrieve_desc8(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_retrieve_desc8(inputs)
	return en_svc_rag_knowledge_assistants_retrieve_desc8(inputs)
});
export { svc_rag_knowledge_assistants_retrieve_desc8 as "svc_rag-knowledge-assistants_RETRIEVE_desc" }